<script setup lang="ts"></script>

<template>
  <div class="illustration">
    <svg viewBox="0 0 112 106" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M54.975 43.287V89.388H1.11V24.173H35.898L54.975 43.287Z"
        fill="white"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M54.974 43.287H35.897V24.173"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.454 75.896H42.631"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.454 64.65H42.631"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.454 53.408H42.631"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.454 42.161H25.798"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M110.621 31.272V104.013H25.628V1.111H80.52L110.621 31.272Z"
        fill="white"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M110.804 31.272H80.703V1.111"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        class="accent"
        d="M39.11 89.111H72.11"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38.933 42.74H84.971"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38.933 21.291H58.411"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38.933 32.306H58.411"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38.933 52.653H86.09"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38.933 62.653H86.09"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38.933 72.653H86.09"
        stroke="currentColor"
        stroke-width="2.221"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
.illustration {
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: rgb(var(--v-theme-on-surface-high-xqes));
    width: 112px;
    height: auto;

    .accent {
      color: rgb(var(--v-theme-brand-accent-xqes));
    }
  }
}
</style>
